<template>
	<transition name="modal">
	    <div class="modal-mask">
	      <div class="modal-wrapper">
	        <div class="modal-container" v-click-outside="close">

	          <div class="modal-close">
	            <slot name="closeModal">
	              x
	            </slot>
	          </div>

	          <div class="modal-header">
	            <slot name="header">
	              default header
	            </slot>
	          </div>

	          <div class="modal-body">
	            <slot name="body">
	              default body
	            </slot>
	          </div>

	          <div class="modal-footer">
	            <slot name="footer">
	              default footer
	              <button class="modal-default-button" @click="$emit('close')">
	                OK
	              </button>
	            </slot>
	          </div>
	        </div>
	      </div>
	    </div>
	</transition>


</template>

<script>
  export default {
    name: "modal",
    props: {
      width: {
        type: String,
        default: "down"
      },
    },

    data() {
    	return{
    		count:0,
    	}
    },

    methods: {
      close() {
      	if(this.count!=0){
      		this.$emit('close');
      	}
      	this.count += 1;
      },
    }

  };
</script>


<style>

	.modal-mask {
	  position: fixed;
	  z-index: 9999;
	  top: 0;
	  left: 0;
	  width: 100%;
	  height: 100%;
	  background-color: rgba(33, 65, 100, 0.79);
	  display: table;
	  -webkit-transition: opacity .3s ease;
	  -o-transition: opacity .3s ease;
	  transition: opacity .3s ease;
	}

	.modal-wrapper {
	  display: table-cell;
	  vertical-align: middle;
	}

	.modal-container {
	  width: 300px;
	  margin: 0px auto;
	  padding: 30px 35px;
	  background-color: #fff;
	  border-radius: 2px;
	  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
	          box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
	  -webkit-transition: all .3s ease;
	  -o-transition: all .3s ease;
	  transition: all .3s ease;
	  font-family: Helvetica, Arial, sans-serif;
	  border-radius: 35px;
	  position: relative;
	}
	.modal-close {
	    position: absolute;
	    width: 30px;
	    height: 30px;
	    text-align: center;
	    line-height: 30px;
	    top: 10px;
	    right: 10px;
	    cursor: pointer;
	    z-index: 9;
	    opacity: 1;
	}

	.modal-close>div {
	    position: fixed;
	    width: 30px;
	    height: 30px;
	    -webkit-box-shadow: 0px 0px 6px #00000045;
	            box-shadow: 0px 0px 6px #00000045;
	    border-radius: 100%;
	    background: #fff;
	    z-index: 9;
	}

	.modal-header h3 {
	  color: #214163;
	  font-family: Lato;
	  font-size: 26px;
	  font-weight: 700;
	  line-height: 31px;
	  letter-spacing: 1.625px;
	}

	.modal-body {
	  margin: 20px 0;
	}

	.modal-default-button {
	  /*float: right;*/
	}

	/*
	 * The following styles are auto-applied to elements with
	 * transition="modal" when their visibility is toggled
	 * by Vue.js.
	 *
	 * You can easily play with the modal transition by editing
	 * these styles.
	 */

	.modal-enter {
	  opacity: 0;
	}

	.modal-leave-active {
	  opacity: 0;
	}

	.modal-enter .modal-container,
	.modal-leave-active .modal-container {
	  -webkit-transform: scale(1.1);
	  -ms-transform: scale(1.1);
	      transform: scale(1.1);
	}

	.modal-container {
	    max-height: 80vh;
	    overflow: hidden;
	    overflow-y: scroll;
	}

	@media only screen and (max-width: 767px){ 
	    .modal-container {
	        max-height: 80vh;
	        overflow: hidden;
	        overflow-y: scroll;
	    }
	   /* .modal-container::-webkit-scrollbar {
	        display: none;
	    }*/
	}
</style>